module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/pizza.png?890ee1693d31c7af82732eb194fb61d2";